import { render } from "./App.vue?vue&type=template&id=495bdb78&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=495bdb78&lang=css"
import "./App.vue?vue&type=style&index=1&id=495bdb78&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=2&id=495bdb78&lang=css"

import exportComponent from "D:\\corpsbattle\\cb-web\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495bdb78"]])

export default __exports__